import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b125ce04&scoped=true"
import script from "./component.js?vue&type=script&lang=js&external"
export * from "./component.js?vue&type=script&lang=js&external"
import style0 from "./index.vue?vue&type=style&index=0&id=b125ce04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b125ce04",
  null
  
)

export default component.exports